import React, { useState, useEffect } from "react";
import ProfileUpload from "../ProfileUploader";
import placeholderImg from "@src/assets/Signup/profile.png";
import profileCamera from "@src/assets/profileCamera.svg";
import { uploadExpertProfileImage } from "@src/api/expert/expertApi";
import styled from "styled-components";
import { getDeviceType, transferToNative, WebAppBridge } from "@src/lib/WebAppBridge";

type Props = {
    profile: string;
    fileUrl?: string;
    isEditing: boolean;
    onProfileChange: (url: string) => void;
};

const UserInfoProfileUploadContainer: React.FC<Props> = ({
    profile,
    fileUrl,
    isEditing,
    onProfileChange,
}) => {
    const [uploading, setUploading] = useState(false);
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const currentImageUrl = profile || fileUrl || "";

    useEffect(() => {
        if (getDeviceType() !== "android") return;

        WebAppBridge.onGetProfileImage = (imageUrl: string) => {
            onProfileChange(imageUrl);
        };

        return () => {
            WebAppBridge.onGetProfileImage = undefined as any;
        };
    }, [onProfileChange]);

    const handleFileSelected = async (file: File) => {
        if (!isEditing) return;
        try {
            setUploading(true);
            const url = await uploadExpertProfileImage(file);
            onProfileChange(url);
        } catch {
            alert("이미지 업로드에 실패했습니다.");
        } finally {
            setUploading(false);
        }
    };

    const handleCameraClick = () => {
        if (!isEditing) return;
        if (getDeviceType() === "android") {
            transferToNative("", "onClickProfile");
            return;
        }
        fileInputRef.current?.click();
    };

    return (
        <ProfileUploadWrap>
            <ProfileUpload
                imageUrl={currentImageUrl}
                placeholderSrc={placeholderImg}
                readOnly={!isEditing}
                isUploading={uploading}
                onFileSelected={handleFileSelected}
                addLabel=""
                showCameraIcon={true}
            />
            <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) handleFileSelected(file);
                }}
            />
            {isEditing && (
                <CameraIconWrap onClick={handleCameraClick}>
                    <img src={profileCamera} alt="프로필 변경" />
                </CameraIconWrap>
            )}
        </ProfileUploadWrap>
    );
};

export default UserInfoProfileUploadContainer;

const ProfileUploadWrap = styled.div`
    position: relative;
    display: inline-block;
`;

const CameraIconWrap = styled.div`
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    z-index: 2;
    cursor: pointer;

    img {
        width: 20px;
        height: 20px;
    }
`;